export const Back = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.375 5.25L5.625 12L12.375 18.75" stroke="#1F1F1F" strokeWidth="2" strokeLinecap="square"/>
        </svg>
    );
  };